import { l10nTranslations } from '../l10n/localization';
import { de } from './Enquiry.i18n.de';
import { it } from './Enquiry.i18n.it';
import { en } from './Enquiry.i18n.en';
import { fr } from './Enquiry.i18n.fr';
import { nl } from './Enquiry.i18n.nl';
import { pl } from './Enquiry.i18n.pl';
const locale = { de, it, en, fr, nl, pl };
export const EnquiryTranslations = l10nTranslations(locale);
//# sourceMappingURL=Enquiry.i18n.js.map